module.exports = __webpack_public_path__ + "static/media/jakarta-utara.f50091fb.svg";